$(function () {
  // 在这里编写需要在文档加载完成后执行的代码
  if (!customElements.get('product-detail-data-popup')) {
    customElements.define(
      'product-detail-data-popup',
      class ProductDetailDataPopup extends HTMLElement {
        productDetailModalBigPictrueSwiper = null;
        productDetailModalSmallPictrueSwiper = null;
        shopMoneyFormat = null;

        constructor() {
          super();
        }

        connectedCallback() {
          this.init();
        }

        init() {
          const _this = this;
          this.shopMoneyFormat = window.shopMoneyFormat;

          // 先销毁已存在的轮播图实例
          if (this.productDetailModalBigPictrueSwiper) {
            this.productDetailModalBigPictrueSwiper.destroy();
          }
          if (this.productDetailModalSmallPictrueSwiper) {
            this.productDetailModalSmallPictrueSwiper.destroy();
          }

          this.initProductDetailModalBigPictrueSwiper();
          this.initProductDetailModalSmallPictrueSwiper();
          this.bindEvents();
        }

        bindEvents() {
          const _this = this;

          // 绑定 variant 选择事件
          const $productVariantSkuItem = $(this).find('.product-variant-sku_item');

          // 获取当前选中的variant并检查库存
          const $activeVariant = $productVariantSkuItem.filter('.product-variant_active');
          if ($activeVariant.length) {
            this.checkInventory($activeVariant.data('variant-inventory-quantity'), $(this), $(this).find('input'));
          }

          $productVariantSkuItem.off('click').on('click', function () {
            $productVariantSkuItem.removeClass('product-variant_active');
            $(this).addClass('product-variant_active');

            $(_this)
              .find('.product-detail-popup_price')
              .text(window.Shopify.formatMoney($(this).data('variant-price'), _this.shopMoneyFormat));
            $(_this)
              .find('.product-detail-popup_price_old')
              .text(window.Shopify.formatMoney($(this).data('variant-compare-at-price'), _this.shopMoneyFormat));
            const $productDetailPopupPriceDiscount = $(_this).find('.product-detail-popup_price_discount');
            const $productDetailPopupPriceDiscountType = $(_this)
              .find('.product-detail-popup_price_discount')
              .data('type');
            if ($productDetailPopupPriceDiscountType == 'quota') {
              $productDetailPopupPriceDiscount.text(
                window.Shopify.formatMoney(
                  $(this).data('variant-compare-at-price') - $(this).data('variant-price'),
                  _this.shopMoneyFormat
                ) + ' OFF'
              );
            } else {
              const discount = $(this).data('variant-compare-at-price') - $(this).data('variant-price');
              const discountPercent = ((discount / $(this).data('variant-compare-at-price')) * 100).toFixed(2);
              $productDetailPopupPriceDiscount.text('-' + discountPercent + ' %');
            }
            _this.checkInventory($(this).data('variant-inventory-quantity'), $(_this), $(_this).find('input'));
            _this.productDetailModalBigPictrueSwiper.slideTo($(this).data('variant-position') - 1);
            _this.productDetailModalSmallPictrueSwiper.slideTo($(this).data('variant-position') - 1);
          });

          // 绑定学习更多按钮事件
          const productDetailPopupButtonLearnMore = $(this).find('.product-detail-popup_button_learn_more');
          productDetailPopupButtonLearnMore.off('click').on('click', function () {
            window.open($(this).data('product-url'), '_blank');
          });

          // 绑定提交按钮事件
          const submitButton = $(this).find('.product-detail-popup_form_wrapper button[type="submit"]');
          submitButton.off('click').on('click', function (event) {
            event.preventDefault();
            const productVariantId = $(_this.querySelector('.product-variant_active')).data('product-variant-id');
            const inputNumber = $(_this.querySelector('.global-number_input'));
            const quantity = inputNumber.val();
            _this.addToCart(this, productVariantId, quantity);
          });

          // 绑定关闭按钮事件
          const $productDetailModalClose = $(this).find('.product-detail-modal_close');
          $productDetailModalClose.off('click').on('click', function () {
            const $productDetailModal = $('product-detail-data-popup');
            $productDetailModal.addClass('hidden').removeClass('flex');
            window.litime.enableScroll();
          });
        }

        initProductDetailModalBigPictrueSwiper() {
          const _this = this;
          const $productDetailModalBigPictrueSwiper = this.querySelector('.product-detail-modal_big_pictrue_swiper');
          this.productDetailModalBigPictrueSwiper = new Swiper($productDetailModalBigPictrueSwiper, {
            initialSlide: 2,
            slidesPerView: 1,
            slidesPerGroup: 1,
            navigation: {},
            on: {
              slideChange: function () {
                if (_this.productDetailModalSmallPictrueSwiper) {
                  _this.productDetailModalSmallPictrueSwiper.slideTo(this.activeIndex);
                }
              },
            },
          });
        }

        initProductDetailModalSmallPictrueSwiper() {
          const _this = this;
          const $productDetailModalSmallPictrueSwiper = this.querySelector(
            '.product-detail-modal_small_pictrue_swiper'
          );
          const $next = this.querySelector('.small_pictrue_swiper_next');
          const $prev = this.querySelector('.small_pictrue_swiper_prev');
          this.productDetailModalSmallPictrueSwiper = new Swiper($productDetailModalSmallPictrueSwiper, {
            initialSlide: 2,
            slidesPerView: 5,
            centeredSlides: true,
            slideToClickedSlide: true,
            slidesPerGroup: 1,
            spaceBetween: 16,
            on: {
              slideChange: function () {
                if (_this.productDetailModalBigPictrueSwiper) {
                  _this.productDetailModalBigPictrueSwiper.slideTo(this.activeIndex);
                }

                if (this.isBeginning) {
                  $($prev).removeClass('flex').addClass('hidden');
                } else {
                  $($prev).removeClass('hidden').addClass('flex');
                }
                if (this.isEnd) {
                  $($next).addClass('hidden');
                } else {
                  $($next).removeClass('hidden');
                }
              },
            },
            navigation: {
              nextEl: $next,
              prevEl: $prev,
            },
          });
        }

        checkInventory(variantInventoryQuantity, $modal, $input) {
          if (+variantInventoryQuantity <= 0) {
            $modal.find('.product-detail-popup_soldout').removeClass('hidden');
            $modal.find('.product-detail-popup_button').addClass('hidden');
            $input.attr('max', 1);
            $input.val(1);
          } else {
            $modal.find('.product-detail-popup_soldout').addClass('hidden');
            $modal.find('.product-detail-popup_button').removeClass('hidden').addClass('flex');
            $input.attr('max', variantInventoryQuantity);
            $input.val(1);
          }
        }

        addToCart(event, productId, quantity) {
          const _this = this;

          $(event).find('.rotate_icon').removeClass('hidden').addClass('flex');
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              items: [
                {
                  id: productId,
                  quantity,
                },
              ],
              sections: 'cart-drawer,cart-icon-bubble',
            }),
          })
            .then((response) => response.json())
            .then((data) => {
              if (window.gtag) {
                gtag('event', 'conversion', { send_to: 'AW-11059876179/OfmnCMjGxIsYENOi4Zkp' });
              }

              // 在此处处理成功添加到购物车后的行为（如弹出通知等）
              $(event).find('.rotate_icon').addClass('hidden').removeClass('flex');

              if (data.status && data.status != 200) {
                window.litime.showToast('error', data.message);
              } else {
                window.litime.enableScroll();
                const $productDetailModal = $('product-detail-data-popup');
                $productDetailModal.addClass('hidden').removeClass('flex');
                const inputNumber = $(_this.querySelector('.global-number_input'));
                const inputMax = inputNumber.attr('max');
                // 修改input的max值
                inputNumber.attr('max', inputMax - quantity);
                // 修改input的value值
                inputNumber.val(1).trigger('change');
                if (window.location.href.includes('cart')) {
                  window.location.reload();
                  window.scrollTo(0, 0);
                  return;
                } else {
                  // 使用 updateCartComponents 更新购物车
                  updateCartComponents(data);
                  // 打开购物车抽屉
                  const cartDrawer = document.querySelector('cart-drawer');
                  if (cartDrawer) {
                    cartDrawer.open();
                  }
                }
              }
            })
            .catch((error) => {
              $(event).find('.rotate_icon').addClass('hidden').removeClass('flex');
            });
        }

        disconnectedCallback() {
          // 清理轮播图实例
          if (this.productDetailModalBigPictrueSwiper) {
            this.productDetailModalBigPictrueSwiper.destroy();
            this.productDetailModalBigPictrueSwiper = null;
          }
          if (this.productDetailModalSmallPictrueSwiper) {
            this.productDetailModalSmallPictrueSwiper.destroy();
            this.productDetailModalSmallPictrueSwiper = null;
          }
        }
      }
    );
  }
});
